import { defaultRouteForLevel } from "@/auth/permissions";
import { Spinner } from "@/components/ui";
import { useAuth } from "@/auth/AuthProvider";
import { fetchIsWarehouseAdmin } from "@/auth/api/invite-api";
import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";

export function RequireAdmin() {
  const { session, loading: authLoading } = useAuth();
  const [adminLoading, setAdminLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    if (!session) {
      setAdminLoading(false);
      return;
    }

    let mounted = true;
    fetchIsWarehouseAdmin()
      .then((value) => {
        if (mounted) setIsAdmin(value);
      })
      .catch(() => {
        if (mounted) setIsAdmin(false);
      })
      .finally(() => {
        if (mounted) setAdminLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, [session]);

  if (authLoading || adminLoading) {
    return (
      <div className="flex min-h-dvh items-center justify-center bg-[var(--color-surface-muted)]">
        <Spinner label="Checking leadership access…" />
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/login" replace />;
  }

  if (!isAdmin) {
    return <Navigate to={defaultRouteForLevel("normal")} replace />;
  }

  return <Outlet />;
}
